import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import Util from 'utility';
import UserEdit from './UserEdit/index';

function User() {
    useEffect(() => {
        Util.setPageTitle('Uživatel');
        Util.resetCookbookFilter();
        Util.resetFoodsFilter();
    }, []);

    return (
        <Switch>
            <Route path="/user/edit/:id" component={UserEdit} />
        </Switch>
    );
}

export default User;
